import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {MaterialModule} from '../../app/material.module';
import { CarouselImagesAdd } from './components/add/component';
import {CarouselImagesList} from './components/list/component';
import {CarouselImagesView} from './directives/view/component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [CarouselImagesList, CarouselImagesView, CarouselImagesAdd],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CarouselImagesView],
})
export class CarouselImageModule {}
